import { Button, Container, FormLabel, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import GraphDisplay from './GraphDisplay'
import dataService from '../services/dataService'
import { connect } from 'react-redux'
import { setStart } from '../reducers/StartDateReducer'
import { setEnd } from '../reducers/EndDateReducer'
import { setNotification } from '../reducers/NotificationReducer'
import { setData } from '../reducers/dataReducer'
import DatePicker from 'react-datepicker'
import { createGlobalStyle } from 'styled-components'
import img1 from '../assets/Smarctic3.jpg'
import FadeIn from 'react-fade-in/lib/FadeIn'

const GlobalStyle = createGlobalStyle`
  body {
    background: url(${img1}) no-repeat;
    background-color: #000000;
    background-attachment: fixed;
    margin-bottom: 100px;
    background-size: 100%;
  }
`

const PilotSiteAreena = (props) => {
  const handleClear = () => {
    props.setStart(new Date())
    props.setEnd(new Date())
    props.setData('')
    location.reload()
  }

  const [ smarctic, setSmarctic ] = useState('')


  const fetchSmarctic = async (event) => {
    event.preventDefault()
    if (props.start !== null && props.end !== null) {
      const formatStart = new Date(props.start.getTime()).toISOString()
      const formatEnd = new Date(props.end.getTime()).toISOString()
      try {
        const data = await dataService.getSmarctic1({
          url: 'smarctic1', formatStart, formatEnd
        })
        setSmarctic(data.docs)
      } catch (e) {
        console.log(e)
      }
    }}


  return (
    <FadeIn transitionDuration="3000">
      <Container>
        <React.Fragment>
          <GlobalStyle  />
        </React.Fragment>
        <Typography variant="h3" style={{ color:'white' }}>Pilot Site Lappi Areena</Typography>
        {
          <div className="Home-header">
            Disclaimer: Sensors measurement starts at March 8, 2022 <br></br><br></br><br></br>How sensor value is calculated:<br></br><br></br>



The enthalpy values of the cold cycle given by the refrigeration machine and the calculated instantaneous mass flow of the compressors are used



            <br></br><br></br>That is, the enthalpy of the refrigerant is multiplied by the mass flow at the outlet of the compressors and the same calculation is subtracted from it before the high-pressure valve. It gives the total thermal energy that leaves the refrigerant before the charger
          </div>
        }
        <form className="Home-header" onSubmit={fetchSmarctic}>
          <table>
            <tbody>
              <tr>
                <td>
                  <FormLabel style={{ color: 'white' }}>Starting date:</FormLabel>
                </td>
                <td>
                  <DatePicker
                    autoComplete="off"
                    selected={props.start}
                    name="Start"
                    value={props.start}
                    onChange={date => props.setStart(date)}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <FormLabel style={{ color: 'white' }}>Ending date:</FormLabel>
                </td>
                <td>
                  <DatePicker autoComplete="off" selected={props.end} name="End" value={props.end} onChange={date => props.setEnd(date)}  />
                </td>
              </tr>
            </tbody>
          </table>
          <Button style={{ background:'black', color:'white' }} type="submit">Search</Button>
          <Button style={{ background:'black', color:'white' }} onClick={handleClear}>Clear</Button>
        </form>
        {
          smarctic ?
            <div>
              <hr style= {{ height:'60pt', visibility:'hidden' }} />
              <GraphDisplay
                dataX={smarctic.map(m => m.payload.ts)}
                dataY={smarctic.map(m => m.payload.d[75781] === undefined ? 0 : m.payload.d[75781].v)}
                title="Thermal power loss (kWh)"
              />
              <GraphDisplay
                dataX={smarctic.map(m => m.payload.ts)}
                dataY={smarctic.map(m => m.payload.d[76048] === undefined ? 0 : m.payload.d[76048].v) }
                title="Heating energy loss (MWh)"
              />
            </div>
            : <p></p>
        }

      </Container>
    </FadeIn>
  )

}

const mapStateToProps = (state) => {
  return {
    notification: state.notification,
    start: state.start,
    end: state.end,
    data: state.data
  }
}

const mapDispatchToProps = {
  setNotification,
  setStart,
  setEnd,
  setData
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PilotSiteAreena)